import React from 'react';
import 'twin.macro';
import tw from 'twin.macro';

interface Props {
  illustration: React.ReactNode;
  title: string;
  description?: React.ReactNode;
  children?: React.ReactNode;
}

export function IllustratedPage(props: Props) {
  const { illustration, title, description, children } = props;

  return (
    <div
      css={[
        tw`h-full px-4 py-8 flex justify-center items-center [@media(min-height:800px)]:my-40 [@media(min-height:800px)]:items-start`,
        tw`md:px-6`,
      ]}
    >
      <div tw="text-center pb-8">
        <div tw="max-w-xs mb-6 md:max-w-none md:mb-12 inline-flex justify-center">
          {illustration}
        </div>
        <h1
          css={[tw`display`, !description && tw`mb-8`, description && tw`mb-2`]}
        >
          {title}
        </h1>
        {description && (
          <div tw="mb-8 text-neutral-quiet text-balance">{description}</div>
        )}
        {children && (
          <div tw="flex flex-col gap-3 w-full sm:w-auto sm:inline-flex">
            {children}
          </div>
        )}
      </div>
    </div>
  );
}
